import React, { useState } from 'react';

const API = 'https://green-energy.com.co/api';

export default function MiPerfil({ usuario, onLogout }) {
  const [pwdActual, setPwdActual] = useState('');
  const [pwdNueva, setPwdNueva] = useState('');
  const [pwdConfirm, setPwdConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const showMsg = (ok, txt) => {
    setMsg({ok, txt});
    setTimeout(()=>setMsg(null), 4000);
  };

  const cambiarPassword = async (e) => {
    e.preventDefault();
    if (pwdNueva !== pwdConfirm) { showMsg(false, 'Las contraseñas nuevas no coinciden'); return; }
    if (pwdNueva.length < 6) { showMsg(false, 'La contraseña debe tener al menos 6 caracteres'); return; }
    setSaving(true);
    try {
      const resp = await fetch(`${API}/usuarios/cambiar-password`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify({ passwordActual: pwdActual, passwordNueva: pwdNueva })
      });
      const data = await resp.json();
      if (data.ok) {
        showMsg(true, 'Contraseña actualizada correctamente');
        setPwdActual(''); setPwdNueva(''); setPwdConfirm('');
      } else {
        showMsg(false, data.error || 'Error al cambiar contraseña');
      }
    } catch(e) { showMsg(false, 'Error de conexión'); }
    setSaving(false);
  };

  const rolConfig = {
    admin:    { label:'Administrador', color:'#f87171' },
    operador: { label:'Operador',      color:'#60a5fa' },
    lectura:  { label:'Solo lectura',  color:'var(--accent)' },
  };
  const rc = rolConfig[usuario.rol] || rolConfig.lectura;

  const permisosList = [
    { key:'dashboard',   label:'🏠 Dashboard' },
    { key:'monitor',     label:'📡 Monitor en vivo' },
    { key:'comandos',    label:'⚡ Enviar comandos' },
    { key:'historial',   label:'📋 Historial' },
    { key:'exportar',    label:'📊 Exportar reportes' },
    { key:'gestion',     label:'⚙️ Gestión de carga' },
    { key:'alertas',     label:'🚨 Alertas' },
    { key:'uptime',      label:'📶 Uptime' },
    { key:'diagnostico', label:'🔬 Diagnóstico' },
    { key:'usuarios',    label:'👥 Usuarios' },
  ];

  return (
    <div>
      <div className="page-title">Mi perfil</div>

      <div className="grid2">
        {/* Info del usuario */}
        <div className="card">
          <div className="card-title">Información de cuenta</div>
          <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
            <div>
              <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'4px',textTransform:'uppercase'}}>Nombre</div>
              <div style={{fontSize:'16px',fontWeight:'700',color:'var(--text)'}}>{usuario.nombre}</div>
            </div>
            <div>
              <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'4px',textTransform:'uppercase'}}>Correo</div>
              <div style={{fontSize:'14px',color:'var(--text2)'}}>{usuario.email}</div>
            </div>
            <div>
              <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'4px',textTransform:'uppercase'}}>Rol</div>
              <span style={{background:'var(--bg)',color:rc.color,padding:'4px 12px',borderRadius:'6px',fontSize:'13px',fontWeight:'600',border:`1px solid ${rc.color}33`}}>
                {rc.label}
              </span>
            </div>
            <div>
              <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'4px',textTransform:'uppercase'}}>COP asignado</div>
              <div style={{fontSize:'14px',color:'var(--text2)'}}>{usuario.cop === 'todos' ? 'Todos los COP' : usuario.cop}</div>
            </div>
          </div>
        </div>

        {/* Permisos */}
        <div className="card">
          <div className="card-title">Mis permisos</div>
          <div style={{display:'flex',flexDirection:'column',gap:'6px'}}>
            {permisosList.map(p => {
              const tiene = usuario.permisos?.[p.key] !== false && usuario.permisos?.[p.key] !== undefined ? usuario.permisos[p.key] : false;
              return (
                <div key={p.key} style={{display:'flex',alignItems:'center',gap:'10px',padding:'6px 10px',borderRadius:'7px',
                  background:tiene?'var(--accent3)':'var(--bg)',border:`1px solid ${tiene?'var(--accent)':'var(--border)'}`}}>
                  <span style={{fontSize:'14px',color:tiene?'var(--accent)':'var(--text4)',fontWeight:'700'}}>{tiene?'✓':'✗'}</span>
                  <span style={{fontSize:'13px',color:tiene?'var(--text)':'var(--text3)'}}>{p.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Cambiar contraseña */}
      <div className="card" style={{maxWidth:'480px'}}>
        <div className="card-title">Cambiar contraseña</div>

        {msg && (
          <div style={{background:msg.ok?'var(--accent3)':'rgba(248,113,113,0.1)',border:`1px solid ${msg.ok?'var(--accent)':'#f87171'}`,
            borderRadius:'8px',padding:'10px 14px',marginBottom:'1rem',fontSize:'13px',color:msg.ok?'var(--accent)':'#f87171'}}>
            {msg.ok?'✅':'❌'} {msg.txt}
          </div>
        )}

        <form onSubmit={cambiarPassword}>
          <div style={{marginBottom:'12px'}}>
            <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'5px',textTransform:'uppercase'}}>Contraseña actual</label>
            <input type="password" value={pwdActual} onChange={e=>setPwdActual(e.target.value)}
              placeholder="••••••••" required style={{width:'100%'}} />
          </div>
          <div style={{marginBottom:'12px'}}>
            <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'5px',textTransform:'uppercase'}}>Nueva contraseña</label>
            <input type="password" value={pwdNueva} onChange={e=>setPwdNueva(e.target.value)}
              placeholder="••••••••" required style={{width:'100%'}} />
          </div>
          <div style={{marginBottom:'1.25rem'}}>
            <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'5px',textTransform:'uppercase'}}>Confirmar nueva contraseña</label>
            <input type="password" value={pwdConfirm} onChange={e=>setPwdConfirm(e.target.value)}
              placeholder="••••••••" required style={{width:'100%'}} />
          </div>
          <button type="submit" disabled={saving} style={{
            padding:'10px 24px',background:'var(--accent-dark)',border:'1px solid var(--accent)',
            borderRadius:'8px',color:'#fff',cursor:saving?'default':'pointer',
            fontSize:'13px',fontWeight:'700'}}>
            {saving?'⏳ Guardando...':'🔒 Cambiar contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
